<template>
  <TransitionRoot as="template" :show="isOpen(modalName)">
    <Dialog
      as="div"
      static
      class="fixed inset-0 z-50 overflow-y-auto"
      :open="isOpen(modalName)"
    >
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay
          class="fixed inset-0 transition-opacity"
          style="background: rgba(93, 96, 117, 0.1); backdrop-filter: blur(2px)"
        />
      </TransitionChild>

      <div class="flex h-screen items-center justify-center">
        <TransitionChild
          as="template"
          enter="transition ease duration-500 transform"
          enterFrom="opacity-0 translate-y-80"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease duration-300 transform"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-80"
        >
          <div
            class="my-auto flex w-full items-center justify-center px-4 py-10 md:px-0"
            :class="[maxWidth, hideOverflow ? 'overflow-hidden' : '']"
          >
            <BoxWrapper
              class="inline-block w-full transform rounded-[20px] align-middle !shadow-lightgray transition-all"
              theme="white"
              :class="[maxWidth, paddingsClass]"
            >
              <div
                v-if="closeButton"
                class="transition-ease-in-out absolute right-1 top-1 z-50 flex h-10 w-10 items-center justify-center rounded-full hover:cursor-pointer md:right-2 md:top-2"
                @click="onCloseModal(modalName)"
              >
                <img
                  src="@/assets/images/base/icons/close-modal.svg"
                  loading="lazy"
                />
              </div>

              <slot />
            </BoxWrapper>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import BoxWrapper from "@/components/Core/BoxWrapper.vue";
import { mapGetters, mapMutations } from "vuex";
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

export default {
  name: "CoreModalWrapper",
  components: {
    BoxWrapper,
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
  },
  emits: ["opened", "closed", "before-close"],
  props: {
    modalName: {
      type: String,
      default: "",
    },
    maxWidth: {
      type: String,
      default: "",
    },
    paddingsClass: {
      type: [String],
      default: "px-4 py-10 md:px-12",
    },
    hideOverflow: {
      type: [Boolean],
      default: true,
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    isOpenModal(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$emit("opened");
        });
      } else {
        this.$emit("closed");
      }
    },
  },
  computed: {
    isOpenModal() {
      return this.isOpen(this.modalName);
    },
    ...mapGetters({
      isOpen: "modals/isOpenModal",
    }),
  },
  methods: {
    onCloseModal() {
      this.$emit("before-close");

      this.$nextTick(() => {
        this.closeModal(this.modalName);
      });
    },
    ...mapMutations({
      closeModal: "modals/closeModal",
      openModal: "modals/openModal",
    }),
  },
};
</script>
